import React, {Component,Fragment} from "react";
import './index.less'

import PortalHeader from "./header";
import PortalContentTag from "./tag";
import PortalContentIntroduction from "./introduction";
import PortalContentFun from "./fun";
import PortalContentCharacter from "./character";
import PortalContentScene from "./scene";
import PortalContentProduction from "./production";
import PortalContentRecommend from "./recommend";

import { NativeEventSource, EventSourcePolyfill } from 'event-source-polyfill';
let sse = null

export default class Index extends Component{
    constructor(props) {
        super(props)
        this.state = {
            totalChatCount:0
        }
    }
    render() {
        let { totalChatCount } = this.state
        return (
            <Fragment>
                {/*header区域*/}
                <PortalHeader totalChatCount={totalChatCount}></PortalHeader>
                {/*内容区域*/}
                <div className={'portal-content'}>
                    {/*标签*/}
                    <PortalContentTag></PortalContentTag>
                    {/*平台介绍*/}
                    {/*<PortalContentIntroduction></PortalContentIntroduction>*/}
                    {/*平台功能*/}
                    <PortalContentFun></PortalContentFun>
                    {/*平台特色*/}
                    <PortalContentCharacter></PortalContentCharacter>
                    {/*应用场景*/}
                    <PortalContentScene></PortalContentScene>
                    {/*应用产品*/}
                    <PortalContentProduction></PortalContentProduction>
                    {/*相关推荐*/}
                    <PortalContentRecommend></PortalContentRecommend>
                </div>
            </Fragment>
        )
    }

    componentDidMount() {
        // this.getTotalCountData()
    }

    // 获取会话总数
    getTotalCountData = () => {
        let _this = this
        let EventSource = NativeEventSource || EventSourcePolyfill;
        sse = new EventSource(window.apis.getTotalChatCount({}));
        sse.onmessage = function (event) {
            let res = event.data && JSON.parse(event.data)
            if (res && res.code === window.codeConfig.success) {
                _this.setState({ totalChatCount:res.result.totalCount })
            }
        }
    }

    sseClear = () => {
        sse && sse.close && sse.close()
        sse = null;
    }
}